module.exports = __webpack_public_path__ + "img/default-img.09599407.svg";